import "../Styles/Header.css";
import { ReactComponent as Logo } from "../Images/oldlogo.svg";
import DashboardIcon from "../Images/icons/dashboard.png";
import { Link } from "react-router-dom";

function AdminHeader() {
  return (
    <div className="header">
      <Link to="/" className="logo_link">
        <Logo className="logo" />
      </Link>

      <h2>ΚΕΝΤΡΙΚΗ ΔΙΑΧΕΙΡΗΣΗ</h2>
      <img src={DashboardIcon} alt="Dashboard icon" width={20} />
    </div>
  );
}

export default AdminHeader;
